"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const i=require("@mui/material/styles"),l=i.styled("div")(({theme:t})=>({position:"relative",display:"flex",background:t.palette.grey[100]})),o=6,p=i.styled("div",{shouldForwardProp:t=>t!=="width"&&t!=="offset"&&t!=="limit"})(({width:t,offset:e,limit:r})=>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${t}px;
  margin: ${e}px ${o}px ${r}px;
`),a=2,d=i.styled("div",{shouldForwardProp:t=>t!=="top"})(({theme:t,top:e})=>`
  position: absolute;
  width: calc(100% + ${o*2}px);
  left: -${o}px;
  height: ${a}px;
  background: ${t.palette.grey[300]};
  top: ${e}%;
 `);exports.AppointmentsWrapper=p;exports.Interval=d;exports.ModalWrapper=l;
